/* @fflow */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
// $FlowIgnore
import { NativeTypes } from 'react-dnd-html5-backend';

// $FlowIgnore
import Dropzone from 'components/Dropzone';

// No flow ignore method yet for decorators
class FileDropzoneContainer extends Component {
  // $FlowIssue https://github.com/facebook/flow/issues/850
  static propTypes = {
    addFiles: PropTypes.func.isRequired
  };

  onDrop(event: Object): void {
    let files = [];
    for (let i = 0; i < event.files.length; i++) {
      files.push(event.files[i]);
    }
    this.props.addFiles(files);
  }

  render(): React.Element {
    return (
      <Dropzone
        {...this.props}
        accepts={[NativeTypes.FILE]}
        onDrop={(item) => this.onDrop(item)} />
    );
  }
}

export default FileDropzoneContainer;
